import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import GamesScreen from '../screens/GamesScreen';
import VocabularyMaster from '../games/VocabularyMaster';
import OtherGameScreen from '../games/OtherGameScreen';
import GameModeScreen from '../screens/GameModeScreen';
import EchoChamberGame from '../games/EchoChamber/EchoChamberGame';
import StoryChaosGame from '../games/StoryChaos/StoryChaosGame';
import AccountMenu from '../components/AccountMenu';
import { colors } from '../styles/globalStyles';
import type { StackNavigationOptions } from '@react-navigation/stack';

const Stack = createStackNavigator();

const defaultScreenOptions: StackNavigationOptions = {
  headerRight: () => <AccountMenu />,
  headerStyle: {
    backgroundColor: colors.surface,
  },
  headerTintColor: colors.primary,
  headerTitleStyle: {
    fontWeight: '700',
  },
};

export default function GameNavigator() {
  return (
    <Stack.Navigator screenOptions={defaultScreenOptions}>
      <Stack.Screen 
        name="GamesList" 
        component={GamesScreen}
        options={{ 
          title: 'Games',
        }}
      />
      <Stack.Screen 
        name="StoryChaos"
        component={StoryChaosGame}
        options={{ title: 'Story Chaos' }}
      />
      <Stack.Screen 
        name="SayItSlayIt" 
        component={GameModeScreen}
        options={{ title: 'Say It & Slay It' }}
      />
      <Stack.Screen 
        name="EchoChamber" 
        component={EchoChamberGame}
        options={{ title: 'Echo Chamber' }}
      />
      <Stack.Screen 
        name="VocabularyMaster" 
        component={VocabularyMaster}
        options={{ title: 'Vocabulary Master' }}
      />
      <Stack.Screen 
        name="OtherGame" 
        component={OtherGameScreen}
        options={{ title: 'Other Game' }}
      />
    </Stack.Navigator>
  );
} 